module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "breadcrumb-item"
  }, [(_vm.item.to) ? _c('router-link', {
    staticClass: "breadcrumb-link",
    attrs: {
      "to": _vm.item.to
    }
  }, [_vm._v(_vm._s(_vm.item.text))]) : _c('span', {
    staticClass: "breadcrumb-link"
  }, [_vm._v(_vm._s(_vm.item.text))]), _vm._v(" "), (_vm.item.to) ? _c('span', {
    staticClass: "sep"
  }, [_vm._v(_vm._s(_vm.separator))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12c5e300!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppBreadcrumbItem.vue
// module id = 30
// module chunks = 2 3 4 5 6